module.exports = __webpack_public_path__ + "static/media/purple-p.a6eb5e81.svg";